import React from 'react';

import { SketchPicker } from 'react-color';
import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

const SelectColor = () => {
  const { t } = useTranslation();
  const {
    actions: { setProp },
    background,
  } = useNode(({ data: { props } }) => {
    return {
      background: props.background,
    };
  });

  const handleBackgroundColor = (color) => {
    setProp((props) => {
      props.background = color.hex;
    }, 500);
  };

  return (
    <SketchPicker
      onChangeComplete={handleBackgroundColor}
      color={background}
      label={t('background')}
    />
  );
};

export default SelectColor;
